import {UserInput} from "../../http/protocol";
import {UseFormRegister, UseFormSetValue} from "react-hook-form/dist/types/form";
import {FieldErrors, FieldErrorsImpl} from "react-hook-form/dist/types/errors";
import {RegisterOptions} from "react-hook-form/dist/types/validator";
import * as React from "react";
import {useEffect, useState} from "react";
import moment from "moment";
import {formText} from "../user-utils";
import {SelectInput} from "../../user/ui/form";
import {InputError} from "./InputError";
import {Merge, useFormContext} from "react-hook-form";

export const UserDetailsDateInput = (props: {
    input: UserInput,
    setValue: UseFormSetValue<any>,
    minAge: number;
    name: string,
    register: UseFormRegister<any>,
    errors: FieldErrors<any>,
    options: RegisterOptions
}) => {



    const {name, register, errors, options} = props;



    let {getValues} = useFormContext();

    let defArray : string[] = [];
    if (typeof getValues(name as any) === "string") {
        let val = getValues(name as any) as string;
        defArray = val.split("-");
    }


    const [year, setYear] = useState(defArray.length > 0 ? parseInt(defArray[0]) : (new Date().getFullYear() - props.minAge));
    const [month, setMonth] = useState(defArray.length > 1 ?  parseInt(defArray[1]) : 1);
    const [day, setDay] = useState(defArray.length > 2 ?  parseInt(defArray[2]) : 1);

    useEffect(() => {
        if (moment().days(1).year(year).month(month).daysInMonth() <= day + 1) {
            setDay(1);
        }
    }, [year, month]);
    useEffect(() => {
        props.setValue(name, year + "-" + (month < 10 ? "0" + month : month) + "-" + (day < 10 ? "0" + day : day));
    }, [year, month, day]);

    let hasError = false;
    if (name.startsWith("attributes.") && errors.attributes) {
        let attributeName = name.replaceAll("attributes.", "");
        const errorsAttributes = errors.attributes as keyof FieldErrors | Merge<FieldErrors, FieldErrorsImpl<any>>
        hasError = !!errorsAttributes[attributeName as any];
    } else {
        hasError = !!errors[name];
    }
    const {nameText, invalidText, helpText} = formText(name);
    let inputRegister = register(name, options);

    let currentDate = new Date();
    return (
        <div className={"form-group " + (hasError ? "has-error" : "")}>
            <label id={name} className={"forms-label"} htmlFor={name}>{nameText}</label>
            <div className={"dob-selector"}>
                <input type={"text"} style={{display: "none"}} {...inputRegister} />
                <SelectInput name={"year"} input={{value: year}} className={"form-control year"}
                             onChange={(e) => setYear(parseInt(e.target.value))}>
                    {[...Array(100)].map((e, i) => {
                        let displayYear = currentDate.getFullYear() - props.minAge - i;
                        return <option key={displayYear} value={displayYear}>{displayYear}</option>
                    })}
                </SelectInput>
                <SelectInput name={"month"} input={{value: month}} className={"form-control month"}
                             onChange={(e) => setMonth(parseInt(e.target.value))}>
                    {[...Array(12)].map((e, i) => {
                        let month = i + 1;
                        return <option key={month} value={month}>{moment().month(i).format("MMMM")}</option>
                    })}
                </SelectInput>
                <SelectInput name={"day"} input={{value: day}} className={"form-control day"}
                             onChange={(e) => setDay(parseInt(e.target.value))}>
                    {[...Array(moment().days(1).year(year).month(month - 1).daysInMonth())].map((e, i) => {
                        return <option key={i + 1} value={i + 1}>{i + 1}</option>
                    })}
                </SelectInput>
            </div>
            {helpText.length > 0 && !hasError && <span className="help-block">{helpText}</span>}
            {hasError && <InputError name={name} errors={errors} invalidText={invalidText}/>}
        </div>
    )
}